<template>
  <v-container>
    <!-- <v-parallax dark src="../assets/background.png">
      <v-row align="center" justify="center">
    </v-row>-->
    <div class="text-center d-flex pb-4">
      <v-btn @click="all" small>Show all</v-btn>
      <!-- <div>{{ panel }}</div> -->
      <v-btn @click="none" small>Close all</v-btn>
    </div>

    <v-expansion-panels v-model="panel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">General info</v-col>
            <v-col cols="1">
              <v-icon small color="primary">fa-info</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <GeneralHelp1></GeneralHelp1>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Responsiveness - small screens</v-col>
            <v-col cols="1">
              <v-icon small color="primary">mdi-cellphone-check</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content
          ><SmallScreenHelp></SmallScreenHelp
        ></v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Registration</v-col>
            <v-col cols="1">
              <v-icon small color="primary" left>fa-user-plus</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <RegistrationHelp></RegistrationHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Notification Service</v-col>
            <v-col cols="1">
              <v-icon small color="primary" left>fa-sms</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <NotificationServiceHelp></NotificationServiceHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Notification - WhatsApp Group</v-col>
            <v-col cols="1">
              <v-icon small color="primary" left>mdi-whatsapp</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <WhatsAppHelp></WhatsAppHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Live Tracking</v-col>
            <v-col cols="1">
              <v-icon small color="primary" left>fa-map</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <LiveTrackingHelp></LiveTrackingHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Sign In - Landed - Exit</v-col>
            <v-col cols="1">
              <v-icon small color="primary" left>fa-sign-in-alt</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <CheckInHelp></CheckInHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">How to add your position</v-col>
            <v-col cols="1">
              <v-icon small color="primary">fa-map-marker-alt</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <AddPositionHelp></AddPositionHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">How to open/close boxes</v-col>
            <v-col cols="1">
              <v-icon small color="primary">mdi-lock-open-plus</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <OpenEventHelp></OpenEventHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Events/Happenings</v-col>
            <v-col cols="1">
              <v-icon small color="primary">mdi-calendar-clock</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <HappHelp></HappHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Admin help</v-col>
            <v-col cols="1">
              <v-icon small color="primary">mdi-application-cog</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <EventAdminHelp></EventAdminHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header ripple>
          <v-row>
            <v-col cols="4">Other tips</v-col>
            <v-col cols="1">
              <v-icon small color="primary"
                >mdi-lightbulb-question-outline</v-icon
              >
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <OtherTipsHelp></OtherTipsHelp>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-footer color="primary" dark>
      <v-row justify="center" no-gutters>
        <v-col class="primary dark py-4 text-center white--text" cols="6">
          {{ new Date().getFullYear() }} —
          <strong>PG Box Help</strong>
        </v-col>
      </v-row>
    </v-footer>
    <!-- </v-parallax> -->
  </v-container>
</template>

<script>
import GeneralHelp1 from "@/components/help/GeneralHelp1.vue";
import AddPositionHelp from "@/components/help/AddPilotPositionHelp.vue"; //src\components\help\AddPilotPositionHelp.vue
// import AddPositionHelp from "@/components/help/AddPositionHelp.vue";
import RegistrationHelp from "@/components/help/RegistrationHelp.vue";
import CheckInHelp from "@/components/help/CheckInHelp.vue";
import OpenEventHelp from "@/components/help/OpenEventHelp.vue";
import EventAdminHelp from "@/components/help/EventAdminHelp.vue";
import SmallScreenHelp from "@/components/help/SmallScreenHelp.vue";
import OtherTipsHelp from "@/components/help/OtherTipsHelp.vue";
import NotificationServiceHelp from "@/components/help/NotificationServiceHelp.vue";
import HappHelp from "@/components/help/HappHelp.vue";
import WhatsAppHelp from "@/components/help/WhatsAppHelp.vue";
import LiveTrackingHelp from "@/components/help/LiveTrackingHelp.vue";

export default {
  name: "Help",
  props: {
    // helpid: {
    //   type: Number
    // },
    data: {
      type: Array,
    },
    loading: Boolean,
    // color: "primary"
  },
  data() {
    return {
      panel: [],
      items: 9,
      helpid: 0,
    };
  },
  created() {
    // let helpid = window.location.search.substring(1);
    // let params = new URLSearchParams(helpid);
    // this.helpid = params.get("helpid");
    this.helpId = this.$route.params.helpId;

    var id = parseInt(this.helpId);
    console.log(id);
    this.setPanel(id);
  },
  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    setPanel(id) {
      // this.panel = [...Array(this.items).keys()].map(id);
      this.panel = [id];
    },
  },
  components: {
    GeneralHelp1,
    AddPositionHelp,
    RegistrationHelp,
    CheckInHelp,
    OpenEventHelp,
    EventAdminHelp,
    SmallScreenHelp,
    OtherTipsHelp,
    NotificationServiceHelp,
    HappHelp,
    WhatsAppHelp,
    LiveTrackingHelp,
  },
};
</script>